import { render, staticRenderFns } from "./LessonDetails.vue?vue&type=template&id=28a98992&scoped=true"
import script from "./LessonDetails.vue?vue&type=script&lang=js"
export * from "./LessonDetails.vue?vue&type=script&lang=js"
import style0 from "./LessonDetails.vue?vue&type=style&index=0&id=28a98992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a98992",
  null
  
)

export default component.exports